
import angular from 'angular';

const controllerInfo = {
    module: 'ib-insurance-module',
    inject: ['$uibModalInstance', '$scope', '$rootScope'],
    required: []
};
export class InsuranceCubaModalController implements ng.IController {
    constructor (
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope) {}

    /**
     * Initialize modal controller
     */
    $onInit (): void {}

    selectInsuranceDefault = (): void => {
        this.$rootScope.$broadcast('selectInsuranceDefault');
        this.$uibModalInstance.close();
    };

    close = (): void => {
        this.$uibModalInstance.close();
    };

    goToPayments = (): void => {
        this.$uibModalInstance.close();
        this.$rootScope.$broadcast('goToPayments');
    };
}


try {
    InsuranceCubaModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(InsuranceCubaModalController.name, InsuranceCubaModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    InsuranceCubaModalController.$inject = controllerInfo.inject;
    mod.controller(InsuranceCubaModalController.name, InsuranceCubaModalController);
}